<template>
  <div id="app">
    <van-watermark :content="watermarkContent" v-if="shouldShowWatermark" :gap-x="30" :gap-y="30" opacity="0.5"
      :width="180" rotate="-35" />
    <div>
      <router-view></router-view>
    </div>
    <BottomNavigation v-if="showBottomNav" />
    <ChatBubble v-if="isSuperAdmin" />
  </div>
</template>

<script>
import BottomNavigation from './components/BottomNavigation.vue';
import ChatBubble from './components/ChatBubble.vue';

export default {
  name: 'App',
  components: {
    BottomNavigation,
    ChatBubble
  },
  data() {
    return {
      isAuthenticated: false,
      isSuperAdmin: false
    };
  },
  computed: {
    showBottomNav() {
      // 在非登录页面显示底部导航
      return this.$route.name !== 'Login';
    },
    watermarkContent() {
      // 获取当前用户信息并构建水印内容
      const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
      return `${userInfo.phone || '未设置'}-${userInfo.name || '未设置'}`;
    },
    shouldShowWatermark() {
      // 只有在指定路由才显示水印
      const currentPath = this.$route.path;
      // 检查是否是以下路由：
      // 1. speaker/:id/detail 格式
      // 2. /my-speakers
      // 3. /apply
      const showWatermark =
        this.isAuthenticated &&
        (currentPath.match(/^\/speaker\/\d+\/detail$/) ||
          currentPath === '/my-speakers');
      return showWatermark;
    }
  },
  created() {
    this.checkLoginStatus();
  },
  methods: {
    checkLoginStatus() {
      // 检查用户是否已登录
      const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
      this.isAuthenticated = !!userInfo.token;
      this.isSuperAdmin = !!userInfo.isSuperAdmin;

      // 定义不需要登录即可访问的页面名称
      const publicPages = ['Login'];

      // 获取当前页面是否为公共页面
      const isPublicPage = publicPages.includes(this.$route.name);

      // 如果未登录且尝试访问受保护页面，则重定向到登录页面
      if (!this.isAuthenticated && !isPublicPage) {
        // 只有当不在登录页面时才进行重定向，避免循环
        if (this.$route.name !== 'Login') {
          this.$router.push('/'); // 假设 '/' 是登录页面的路由
        }
        return;
      }

      // 如果已登录但访问登录页面，则重定向到首页
      if (this.isAuthenticated && this.$route.name === 'Login') {
        this.$router.push('/home');
      }
    }
  },
  watch: {
    // 监听路由变化，检查登录状态
    '$route'(to, from) {
      this.checkLoginStatus();
    }
  }
}
</script>

<style>
/* 全局样式设置 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
}

/* 定义主色调变量 */
:root {
  --primary-yellow: #E5A170;
  --primary-blue: #145294;
}

#app {
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #333;
  margin-top: 0;
}

/* 公共页面结构样式 */
.base-basic {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

/* 页面主体内容 */
.body-content {
  flex: 1;
  padding-bottom: 70px;
  /* 为底部导航栏预留空间 */
}

/* 页面标题样式 */
.page-title {
  margin-bottom: 0;
}

.van-nav-bar {
  margin-bottom: 0 !important;
}

.custom-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 50px;
  background-color: #fff;
  display: flex;
  align-items: center;
  padding: 0 16px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 999;
}

</style>